import { render } from "./Details.vue?vue&type=template&id=d7ad64a0&scoped=true"
import script from "./Details.vue?vue&type=script&lang=ts"
export * from "./Details.vue?vue&type=script&lang=ts"

import "./Details.vue?vue&type=style&index=0&id=d7ad64a0&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-d7ad64a0"

export default script